import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { Title } from "@angular/platform-browser";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

const version_str: string = environment.version_app;

// Opción rápida: título por DOM (antes de bootstrap)
document.title = "Sysne " + version_str;

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(appRef => {
    // Opción Angular: usar Title service desde el injector
    const title = appRef.injector.get(Title);
    title.setTitle("Sysne " + version_str);
  })
  .catch(err => console.error(err));
